module.exports = __webpack_public_path__ + "static/img/096_TO8_1773.438ecf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/096_TO8_1773.jpg
// module id = rKoG
// module chunks = 0